module.exports = __webpack_public_path__ + "img/samsung_g991b.516643b.jpg";